export default __webpack_public_path__ + "static/media/excel.5b54e07c.png";